import Game from '../../game';
import BaseObject, { BaseObjectParams } from '../../baseObject';
import Menu from './menu';
import Camera from '../../camera';

import { SpriteParams } from '../../sprite/sprite';
import { isBetween } from '../../../utils/math';


export type itemFunctionType = (element?: MenuButton) => void;

export interface MenuButtonParams extends BaseObjectParams {
  menu: Menu;
  row: number;
  x: number;
  y: number;
  width: number;
  height: number;
  ignoreCamera: boolean;
  spriteParams: SpriteParams;
  caption: string;
  hover: boolean;
  onSelect: itemFunctionType;
}

export default class MenuButton extends BaseObject implements MenuButtonParams {
  menu!: Menu;
  row!: number;
  x: number = 0;
  y: number = 0;
  width: number = 10;
  height: number = 10;
  ignoreCamera: boolean = false;
  spriteParams!: SpriteParams;
  caption!: string;
  hover = false;
  onSelect!: itemFunctionType;

  constructor(params: MenuButtonParams) {
    super();
    this.applyParams(params);
  }

  get camera(): Camera {
    return Game.instance.scene.camera;
  }

  get drawWidth(): number {
    return this.width / ((this.ignoreCamera) ? Game.instance.scene.zoomRatio : 1);
  }

  get drawHeight(): number {
    return this.height / ((this.ignoreCamera) ? Game.instance.scene.zoomRatio : 1);
  }

  get startX(): number {
    return this.x / ((this.ignoreCamera) ? Game.instance.scene.zoomRatio : 1) + ((this.ignoreCamera) ? this.camera.x - this.camera.width / 2 : 0);
  }

  get endX(): number {
    return this.startX + this.drawWidth;
  }

  get startY(): number {
    return this.y / ((this.ignoreCamera) ? Game.instance.scene.zoomRatio : 1) + ((this.ignoreCamera) ? this.camera.y - this.camera.height / 2 : 0);
  }

  get endY(): number {
    return this.startY + this.drawHeight;
  }

  draw(): CanvasRenderingContext2D {
    const { startX, startY, drawWidth, drawHeight, caption, menu: { context: ctx }, hover } = this;
    ctx.save();
    ctx.fillStyle = 'grey';
    ctx.fillRect(startX, startY, drawWidth, drawHeight);
    ctx.fillStyle = (hover) ? 'red' : 'black';
    ctx.textAlign = 'center';
    ctx.font = `${12 / Game.instance.scene.camera.zoomRatio}px Arial`;
    ctx.fillText(caption, startX + drawWidth / 2, startY + drawHeight / 2);
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 2 / Game.instance.scene.camera.zoomRatio;
    ctx.strokeRect(startX, startY, drawWidth, drawHeight);
    ctx.restore();
    return this.menu.context;
  }

  select(): void {
    this.onSelect(this);
  }

  checkCollisionWithCoords(coordsX: number, coordsY: number): boolean {
    const { startX, startY, endX, endY } = this;
    const onme = (
      isBetween(coordsX, startX, endX)
      && isBetween(coordsY, startY, endY)
    );
    return onme;
  }
}
